(function () {
  'use strict';

  /*
    A CUE TILE NEVER SHOWS AN EMPTY PICTURE AREA (2026-10-06, the owner's rule
    after the Innovation MH white block).

    The composite draws its cue as three or four absolutely positioned band
    rows, each an <img> of an asset named from the block's band key. When one
    of those files does not resolve - a key that is wrong, an asset that was
    never cut, a CDN miss - the browser draws nothing and leaves the row's
    space white. That is what Innovation MH looked like for a day: rows 1 and
    2 at HTTP 404 with naturalWidth 0, rows 3 and 4 painting normally, because
    the shaft strips come off the selected option and the butt strips come off
    the key.

    This guard does two things, in the order the owner asked for:

    1. TRY THE MODEL'S OTHER OPTIONS. Every swatch carries the band URLs of
       its own option (data-longoni-preview-row-1..4, written by
       snippets/lg-swatch.liquid), so a row that fails is retried against the
       DISTINCT values its siblings hold. On today's catalogue the butt rows
       are one pair per model and every option repeats them, so this pass
       finds nothing new for rows 1 and 2 and is the real fallback for the
       shaft rows, where options differ by design. It costs one attempt per
       distinct URL and never loops: what has been tried is recorded on the
       element.

    2. FAILING THAT, DRAW NOTHING RATHER THAN WHITE. The row is hidden with
       visibility:hidden - the same mechanism Liquid already uses for a tile
       whose option has no third band - so the composite's geometry, and with
       it the tile's locked height, does not move by a pixel. There is no
       space to "collapse": the rows are absolute, so their boxes are not in
       the flow and hiding one leaves everything else where it stands.

    The tile and the row are marked data-band-missing so the next reader can
    find this in the DOM instead of wondering, and scripts/check-band-assets.ps1
    catches the same class of fault in the repo before it ever ships.

    error does not bubble, so the listener is on the document in the CAPTURE
    phase - the only way to hear it for images this script did not create.
    Images that failed before this file ran are swept once at startup, which
    is what covers the first five tiles of a rail (they ship with src) as well
    as the deferred ones (bc-tile-lazy swaps data-src in later).
  */

  if (window.BCBandGuard) return;

  var ROW_IMG = '.mcd-tile__cue-row img';
  var ATTR = 'data-longoni-preview-row-';

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(sel)) return el;
      el = el.parentNode;
    }
    return null;
  }

  // The distinct URLs this model's own swatches hold for this band row.
  function candidates(tile, index) {
    var attr = ATTR + index;
    var out = [];
    var nodes = tile.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < nodes.length; i += 1) {
      var v = nodes[i].getAttribute(attr);
      if (v && out.indexOf(v) === -1) out.push(v);
    }
    return out;
  }

  function hide(img, row, tile) {
    img.style.visibility = 'hidden';
    if (row) row.setAttribute('data-band-missing', 'true');
    if (tile) tile.setAttribute('data-band-missing', 'true');
  }

  function handle(img) {
    if (!img || img.getAttribute('data-band-guard') === 'done') return;
    var row = closest(img, '.mcd-tile__cue-row');
    var tile = closest(img, '.mcd-tile');
    if (!row || !tile) { hide(img, row, tile); return; }

    var rows = tile.querySelectorAll('.mcd-tile__cue-row');
    var index = 0;
    for (var i = 0; i < rows.length; i += 1) { if (rows[i] === row) { index = i + 1; break; } }

    var current = img.getAttribute('src') || '';
    var tried = (img.getAttribute('data-band-tried') || '').split('|');
    if (current && tried.indexOf(current) === -1) tried.push(current);

    var pool = candidates(tile, index);
    for (var k = 0; k < pool.length; k += 1) {
      if (tried.indexOf(pool[k]) === -1) {
        img.setAttribute('data-band-tried', tried.join('|'));
        img.setAttribute('data-band-fallback', 'option');
        img.src = pool[k];
        return;
      }
    }

    img.setAttribute('data-band-guard', 'done');
    hide(img, row, tile);
  }

  function sweep(root) {
    var imgs = (root || document).querySelectorAll(ROW_IMG);
    for (var i = 0; i < imgs.length; i += 1) {
      var img = imgs[i];
      if (img.getAttribute('src') && img.complete && img.naturalWidth === 0) handle(img);
    }
  }

  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.matches && t.matches(ROW_IMG)) handle(t);
  }, true);

  // A fetched row arrives after load; its own <script> tags never run, so the
  // sweep is re-run on the event the loaders dispatch on the injected root.
  document.addEventListener('shopify:section:load', function (e) { sweep(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sweep(document); });
  } else {
    sweep(document);
  }
  window.addEventListener('load', function () { sweep(document); });

  window.BCBandGuard = { handle: handle, sweep: sweep };
}());
